import axios from 'axios';
import { JUNCTURES_LIST_BY_PROPERTY } from '../../constants';

export const fetchJuncturesListByProperty = (id, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadJuncturesListByProperty());

  axios
    .get(`/client/property/${id}/listJunctures`, config)
    .then((res) => dispatch(setJuncturesListByProperty(res)))
    .catch((err) => {
      dispatch(errorJuncturesListByProperty(err.response));
      onError(err.response);
    });
};

export const loadJuncturesListByProperty = () => ({
  type: JUNCTURES_LIST_BY_PROPERTY.LOAD,
});

export const setJuncturesListByProperty = (userList) => ({
  type: JUNCTURES_LIST_BY_PROPERTY.SUCCESS,
  payload: userList.data.data,
});

export const errorJuncturesListByProperty = (error) => ({
  type: JUNCTURES_LIST_BY_PROPERTY.FAIL,
  payload: error,
});
